import { imageUrl } from '@/data/site';

export const TRUST_ITEMS = [
  { title: 'Od 1994. godine', text: 'Sarajevo, Ilidža — Željeznička 112.' },
  { title: 'Šest područja rada', text: 'Od velikih formata do protokolarnih rješenja.' },
  { title: 'Od ideje do montaže', text: 'Dizajn, štampa, isporuka i montaža.' },
  { title: 'Realizovani projekti', text: 'Pogledajte naše radove.', href: '#portfolio' },
];

export const PROCESS_STEPS = [
  { title: 'Pošaljete upit ili ideju', text: 'Opišite šta vam treba ili pošaljite fotografiju prostora, vozila ili materijala.' },
  { title: 'Dogovorimo materijale, dimenzije i rok', text: 'Zajedno definišemo veličine, materijale i termin izrade.' },
  { title: 'Pripremimo dizajn i potvrdu', text: 'Pripremamo dizajn i šaljemo vam ga na odobrenje prije štampe.' },
  { title: 'Štampa, isporuka i montaža', text: 'Izrađujemo, isporučujemo i, gdje je potrebno, montiramo na lokaciji.' },
];

export const WHY_ITEMS = [
  { title: 'Sve na jednom mjestu', text: 'Štampa, brendiranje prostora i vozila, tekstil i event oprema kod jednog partnera.' },
  { title: 'Rješenja po mjeri', text: 'Dimenzije, materijale i rokove prilagođavamo vašem projektu.' },
  { title: 'Od dizajna do montaže', text: 'Pratimo projekat od ideje do postavljanja na lokaciji.' },
  { title: 'Projekti koje možete vidjeti', text: 'Naši radovi su stvarni projekti za firme, klubove, institucije i događaje.' },
  { title: 'Lokalni tim u Sarajevu', text: 'Direktan razgovor, dogovor i preuzimanje na našoj adresi na Ilidži.' },
];

export const WHY_IMAGE = {
  galleryId: '080.jpg',
  src: imageUrl('IMG-575dbc7444a99443e84efd374a636d58-V.jpg'),
  alt: 'Brendirani sajamski štand s velikom štampanom grafikom i pultom',
};

export const FAQ_ITEMS = [
  {
    q: 'Kako mogu zatražiti ponudu?',
    a: 'Pošaljite nam ideju, dimenzije ili fotografiju prostora na email garmond@garmond.ba. Pomoći ćemo vam da pronađete odgovarajuće rješenje.',
  },
  {
    q: 'Šta mi je potrebno za ponudu?',
    a: 'Dovoljna je ideja. Što više znamo o dimenzijama, materijalu, lokaciji i roku, to je ponuda tačnija.',
  },
  {
    q: 'Gdje se nalazite i kada radite?',
    a: 'Željeznička 112, Ilidža, Sarajevo. Radimo ponedjeljkom do petka od 08:00 do 16:00.',
  },
  {
    q: 'Montirate li ono što izradite?',
    a: 'Naš proces uključuje štampu, isporuku i montažu.',
  },
  {
    q: 'Radite li dizajn?',
    a: 'Pripremamo dizajn i šaljemo ga na potvrdu prije štampe.',
  },
  {
    q: 'Radite li za pojedince ili samo za firme?',
    a: 'Radimo za firme, sportske klubove i institucije, ali i za fizičke osobe.',
  },
  {
    q: 'Koliko traje izrada?',
    a: 'Rok dogovaramo pri ponudi, ovisno o projektu.',
  },
  {
    q: 'Mogu li naručiti manju količinu?',
    a: 'Da, naravno.',
  },
];
